
export function rangeVillage(data) {
  let map = {};
  let val = [];
  // 深拷贝一下Vuex中的villageList数组
  const newData = JSON.parse(JSON.stringify(data))
  //生成数据对象集合
  newData.forEach(it=>{
    map[it.id] = it;
  })
  //生成结果集
  newData.forEach(it=>{
      const parent = map[it.parent_id];
      if (parent) {
          if(!Array.isArray(parent.children)) parent.children = [];
          parent.children.push(it);
      } else {
          val.push(it);
      }
  })
  return val;
}

// 查找一个树多有第一个节点，深度遍历
export function getFirstNode (tree) {
  var temp = []
  var forFn = function (arr) {
    if (arr && arr.length > 0) {
      temp.push(arr[0].id)
      if (arr[0].children) {
        forFn(arr[0].children)
      }
    }
  }
  let tempArr = JSON.parse(JSON.stringify(tree))
  forFn(tempArr)
  return temp
}

export function dateFormat(dateData) {
  var date = new Date(dateData)
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  var d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  const time = y + '-' + m + '-' + d
  return time
}

export function getDefaultDate () {
  let defaultData = []
  let d = new Date()
  let year1,month1,day1;
  [year1,month1,day1] = [d.getFullYear(),d.getMonth(),d.getDate()]
  let date1 = new Date(year1, month1, 1)
  let date2 = new Date(year1, month1, day1)
  defaultData.push(date1)
  defaultData.push(date2)

  return defaultData
}



// WEBPACK FOOTER //
// ./src/assets/js/funcs.js